import { TriangleAlert, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import useWindowSize from 'utils/useWindowSize';
import Modal from '../Modal';
import styles from './SubscriptionExpiryModal.module.scss';

const SubscriptionExpiryModal = ({ isOpen, onClose, expiryDate }) => {
  const { t, i18n } = useTranslation();
  const { isMobile } = useWindowSize();
  const locale = i18n.language || 'it';
  const formattedDate = expiryDate
    ? dayjs(expiryDate).locale(locale).format('D MMMM YYYY')
    : '';

  return (
    <Modal
      width={isMobile ? 'min(340px, calc(100vw - 24px))' : '420px'}
      maxWidth={isMobile ? 'calc(100vw - 24px)' : '420px'}
      height="fit-content"
      maxHeight={isMobile ? 'min(85vh, 85dvh)' : 'fit-content'}
      isModalOpen={isOpen}
      setIsModalOpen={(open) => {
        if (!open) onClose?.();
      }}
      centered
    >
      <div className={styles.shell}>
        <div className={styles.alert_bar} aria-hidden />
        <button
          type="button"
          className={styles.close}
          onClick={onClose}
          aria-label={t('common.actions.close', { defaultValue: 'Chiudi' })}
        >
          <X size={18} strokeWidth={2.2} />
        </button>
        <div className={styles.modal__content}>
          <div className={styles.icon_wrap}>
            <span className={styles.icon_badge} aria-hidden>
              <TriangleAlert size={isMobile ? 26 : 32} strokeWidth={2.2} />
            </span>
          </div>
          <p className={styles.eyebrow}>{t('app.subscriptionExpiry.eyebrow')}</p>
          <h2 className={styles.title}>{t('app.subscriptionExpiry.title')}</h2>
          {formattedDate ? (
            <div className={styles.date_chip}>
              {t('app.subscriptionExpiry.dateChip', { date: formattedDate })}
            </div>
          ) : null}
          <div className={styles.warning_box}>
            <p className={styles.subtitle}>{t('app.subscriptionExpiry.subtitle')}</p>
          </div>
          <div className={styles.actions}>
            <button type="button" className={styles.confirm} onClick={onClose}>
              {t('app.subscriptionExpiry.buttons.close')}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SubscriptionExpiryModal;
